import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Paper,
  Typography,
  Button,
  Menu,
  MenuItem,
  Divider,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import LensIcon from '@mui/icons-material/Lens';
import CloseIcon from '@mui/icons-material/Close';
import RemoveIcon from '@mui/icons-material/Remove';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: '30px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2, 3),
  },
  button: {
    marginRight: theme.spacing(1),
    padding: theme.spacing(0, 1),
    borderColor: '#d2dae1',
    borderRadius: '50px',
    color: '#000',
    fontSize: '12px',
    '&:hover': {
      borderColor: '#9fa5ab',
    }
  },
  chartBody: {
    marginTop: theme.spacing(3),
    height: 400,
  },
  navButton: {
    margin: theme.spacing(0.5),
    width: 'fit-content',
    minWidth: 'unset',
    height: 35,
    fontSize: '14px',
    fontWeight: 'bold',
    borderRadius: '50px',
    textTransform: 'none',
    backgroundColor: '#794b6b',
    borderColor: '#794b6b',
    '&:hover': {
      backgroundColor: '#66445c',
    },
    '& svg': {
      marginRight: theme.spacing(0.5),
      fontSize: '14px',
    },
  },
  actions: {
    width: 'fit-content',
    padding: theme.spacing(1),
    backgroundColor: '#FFF',
    borderRadius: 50,
    margin: '30px auto',
  },
  appendix: {
    margin: '50px auto',
    width: 'fit-content',
  },
  text: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    '& svg': {
      marginRight: '8px',
      color: 'green',
      fontSize: 12,
    }
  }
}));

const DailyChart = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <div className={classes.root}>
      <Paper elevation={0} className={classes.header}>
        <Button variant='outlined' className={classes.button} onClick={() => navigate(-1)}>
          <NavigateBeforeIcon />
          Back
        </Button>
        <Typography>{' / Daily Chart for Practice Cards'}</Typography>

        <Button variant='outlined' className={classes.button} sx={{ marginLeft: 'auto' }} onClick={(e) => setAnchorEl(e.currentTarget)}>
          More
          <ArrowDropDownIcon />
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          className={classes.menu}
        >
          <MenuItem onClick={() => { setAnchorEl(null); navigate('/sets/1/timing'); }}>Timing Chart</MenuItem>
          <MenuItem onClick={() => { setAnchorEl(null); navigate('/sets'); }}>Fluency Cards</MenuItem>
          <MenuItem>Celeration</MenuItem>
          <Divider />
          <MenuItem>Help</MenuItem>
        </Menu>
      </Paper>

      <Paper elevation={0} className={classes.chartBody}></Paper>

      <div className={classes.actions}>
        <Button variant='contained' className={classes.navButton}>
          <ArrowBackIosNewIcon />
        </Button>
        <Button variant='contained' className={classes.navButton}>
          Now
        </Button>
        <Button variant='contained' className={classes.navButton}>
          <ArrowForwardIosIcon />
        </Button>
      </div>

      <div className={classes.appendix}>
        <Typography className={classes.text}>
          <LensIcon />
          Counter per minute
        </Typography>
        <Typography className={classes.text}>
          <CloseIcon />
          Errors per minute
        </Typography>
        <Typography className={classes.text}>
          <RemoveIcon />
          Timings (Record) Floor
        </Typography>
      </div>
    </div>
  )
};

export default DailyChart;
